import {
    ClientsWorkOverviewSortValue,
    ClientsWorkOverviewView,
} from "@common/types/views/clientsWorkOverviewView";
import { omit } from "@common/helpers/objects";

export const DEFAULT_WORK_SORT = ClientsWorkOverviewSortValue.APPLIED_AT_DESC;

/** The view's sort, falling back to the page default when the view has none. */
export const getWorkViewSort = (
    view: ClientsWorkOverviewView,
): ClientsWorkOverviewSortValue => view.filters.workSort ?? DEFAULT_WORK_SORT;

/**
 * Writes `sort` into the view's filters. The default is left out so views saved
 * before sort lived in the view (and the built-in view) compare as unchanged.
 */
export const withWorkViewSort = ({
    view,
    sort,
}: {
    view: ClientsWorkOverviewView;
    sort: ClientsWorkOverviewSortValue;
}): ClientsWorkOverviewView => {
    const filters = omit(view.filters, "workSort");
    return {
        ...view,
        filters:
            sort === DEFAULT_WORK_SORT
                ? filters
                : { ...filters, workSort: sort },
    };
};
